/**
 * track() 包装器 · 调用 posthog.capture 前用 Zod 验证 schema
 *
 * 承接：
 * - T11 §12.5 实现约束："CI 检查未登记的事件名不允许发送" · 本 wrapper 是单点入口
 * - DAC-01 §4.D Biome 锁定 + ADR-505 单主路径（无 if event_name == 分支）
 *
 * 设计要点：
 * - 接收 AdminEventInput（Zod discriminatedUnion）· 类型层 + 运行时双重保障
 * - posthog 实例由调用方注入（避免 packages/analytics 直接耦合 dev/prod posthog 单例）
 * - dev 环境 console.debug 便于排查 · prod 仅 capture
 */
import type { PostHog } from "posthog-js";

import { AdminEvent, type AdminEventInput } from "./events";

export interface TrackOptions {
	/** PostHog 客户端实例（apps/admin 调用方传入 · main.tsx 已 init posthog 单例）*/
	posthog: PostHog;
	/** 是否在 console 打印 · dev 默认 true · prod 默认 false */
	debug?: boolean;
}

export function track(event: AdminEventInput, opts: TrackOptions): void {
	const parsed = AdminEvent.safeParse(event);
	if (!parsed.success) {
		// schema 验证失败 → 不发送 · 仅 console.warn（避免错误埋点污染数据）
		console.warn("[analytics] event schema invalid · drop", {
			event: (event as { event?: string }).event,
			issues: parsed.error.issues,
		});
		return;
	}

	if (opts.debug) {
		console.debug("[analytics]", parsed.data.event, parsed.data.properties);
	}

	opts.posthog.capture(parsed.data.event, parsed.data.properties as Record<string, unknown>);
}
